import React, {Component} from 'react';

import LoginModal from './../../APP/MODALS/LoginModal';
import CommentsModal from "./CommentsModal";
import MarketingModal from "./MarketingModal";
import OwnPriceModal from "./OwnPriceModal";

export default class Modals extends Component {

	constructor(props)
    {
        super(props);
    }

	render() { 
        return (
        	<div>
                <LoginModal />
				<CommentsModal />
				<MarketingModal />
				<OwnPriceModal />
			</div>
    	);
	}
}